import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { record as UsersRecord, actions as UsersActions } from 'data/users'

import { makeToggleable } from 'components/Utils/toggleable'
import Confirm from 'components/Utils/Modal/Confirm'
import { Text } from 'components/base'

export class Archive extends React.Component {
  onConfirmed = event => {
    this.props.archiveUser({ userId: this.props.user.id })
    this.props.closeModal(event)
    this.props.onArchived()
  }

  render() {
    const {
      user,
      children,
      className,
      isModalOpen,
      openModal,
      closeModal,
    } = this.props
    return (
      <div className={className} onClick={openModal}>
        <Confirm
          show={isModalOpen}
          onConfirm={this.onConfirmed}
          onCancel={closeModal}
        >
          <div>
            <Text.Subtitle>Are you sure?</Text.Subtitle>

            <Text.Corpus className="margin-vertical-large">
              You are about to delete the user @{user.username}.<br />
              This action is irrevocable!
            </Text.Corpus>
          </div>
        </Confirm>
        {children}
      </div>
    )
  }
}

const ConnectedArchive = compose(
  makeToggleable({
    attrName: 'isModalOpen',
    toggleOnName: 'openModal',
    toggleOffName: 'closeModal',
    toggleName: 'toggleModal',
    defaultValue: false,
  }),
  connect(
    null,
    { archiveUser: UsersActions.archiveUser }
  )
)(Archive)

ConnectedArchive.propTypes = {
  user: PropTypes.instanceOf(UsersRecord).isRequired,
  onArchived: PropTypes.func,
}

ConnectedArchive.defaultProps = {
  onArchived: () => {},
}

export default ConnectedArchive
